const KEY = "lexv_vocab";
const STOP = new Set("a an the and or but of to in on at for by with from is are was were be been it its this that these those as if so not no do does did have has had i you he she we they them his her our their my your will would can could should may might must there here then than".split(" "));

export const getVocab = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (v) => { localStorage.setItem(KEY, JSON.stringify(v)); window.dispatchEvent(new Event("lexv-vocab")); };
export const isSaved = (w) => getVocab().some((x) => x.word === w.toLowerCase());
export const saveWord = (word, context = "", part = "") => {
  const w = word.toLowerCase();
  if (isSaved(w)) return;
  write([{ word: w, context, part, addedAt: new Date().toISOString(), learned: false }, ...getVocab()]);
};
export const removeWord = (w) => write(getVocab().filter((x) => x.word !== w));
export const toggleLearned = (w) => write(getVocab().map((x) => (x.word === w ? { ...x, learned: !x.learned } : x)));
export const contentWords = (words) => [...new Set(words.map((w) => w.toLowerCase()).filter((w) => w.length > 2 && !STOP.has(w)))];
